import { render, staticRenderFns } from "./modalRegisterMessage.vue?vue&type=template&id=a2fb9e00&scoped=true"
import script from "./modalRegisterMessage.vue?vue&type=script&lang=js"
export * from "./modalRegisterMessage.vue?vue&type=script&lang=js"
import style0 from "./modalRegisterMessage.vue?vue&type=style&index=0&id=a2fb9e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fb9e00",
  null
  
)

export default component.exports